export const hotelRegulationsText = {
    "en-US": `
<b>Dear Guest</b>,
We’re thrilled to have you stay with us at The Grand Arosa Pop-Up Hotel, where we strive to create a cozy, fun, and safe environment for all our guests. To help us maintain this atmosphere, we kindly ask that you follow the house rules outlined below. These guidelines ensure everyone’s comfort, safety, and enjoyment, while also helping us preserve the quality of our property.

1. <b>Security Deposit</b>
A security deposit of 250 CHF is required for every reservation. This deposit will be held on your credit card and released within one week after checkout, provided there are no damages or issues.

2. <b>Self-Check-In</b>
The Grand Arosa Pop-Up Hotel operates with a self-check-in system. To access your room, please complete the Self-Check-In Form sent with your booking confirmation and ensure that your payment is processed. We are not responsible for any access issues if these steps are not completed.

3. <b>Communication & Services</b>
All communication, except in emergencies, should be conducted through our guest portal or by WhatsApp. Rooms are cleaned and prepared before your arrival, but the room rate does not include cleaning services during your stay.

4. <b>No Parties or Events</b>
The Grand Arosa Pop-Up Hotel is a social yet peaceful place. Parties and events that cause noise or disturbances are strictly prohibited to maintain a pleasant environment for all guests.

5. <b>No Smoking</b>
Smoking is prohibited indoors. Please use designated outdoor smoking areas and dispose of cigarette butts responsibly.

6. <b>Pets</b>
Our hotel allows a maximum of one dog per room, with a fee of 50 CHF per dog. We do not permit breeds deemed dangerous (including Pit Bulls, Rottweilers, Dobermans, and American Staffordshire Terriers). Puppies under 6 months of age are not allowed. Dogs must not be left unattended in rooms unless they remain quiet and well-behaved, and they must be kept on a leash in public areas such as the lobby and hallways. Owners are responsible for any damage or extra cleaning costs incurred by their pets.

7. <b>Found Items</b>
If you leave anything behind, it will be kept in our lost and found. Please contact us to arrange a collection, as our office may not always be open.

8. <b>No Unregistered Guests</b>
For security and comfort, only guests listed in the booking are allowed on the premises.

9. <b>Quiet Hours</b>
To ensure a restful environment, quiet hours are from 10:00 PM to 7:00 AM and from 12:00 PM to 1:00 PM. Sundays and public holidays are also considered quiet times.

10. <b>Check-In and Check-Out Times</b>
Please respect our check-in and check-out times to help us manage cleaning schedules and prepare for incoming guests. Check-in time is earliest by 16:00 (4:00 pm)  and check-out time latest by 11:00 am.

11. <b>Key Care</b>
Please take care of your room key. Lost keys will incur a replacement fee of 250 CHF.

12. <b>Respect for Furniture and Property</b>
Treat the property with care and report any damages. If damages exceed the security deposit, additional charges will apply.

13. <b>No Rearranging Furniture</b>
Please do not move or rearrange furniture, as this can cause damage and create extra work for our team.

14. <b>Trash Disposal</b>
Please take out your trash before checking out to keep the hotel tidy.

15. <b>No Illegal Substances</b>
The use or possession of illegal substances is strictly forbidden to ensure a safe and legal environment for all guests.

16. <b>No Prostitution</b>
Prostitution is strictly prohibited at The Grand Arosa Pop-Up Hotel. Violation of this rule will result in a 1000 CHF fine and a report to the authorities.

17. <b>Babies are allowed</b>
Babies are welcome; however, we do not provide baby cots, high chairs, strollers, or any other baby equipment.

By following these rules, you’re helping us keep The Grand Arosa Pop-Up Hotel a welcoming, enjoyable, and safe place for everyone. We appreciate your cooperation and hope you have a fantastic stay!

<b>Warm regards,
The Grand Arosa Pop-Up Hotel  Team</b>
`};
